var _filter, _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1b:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21.1125,
    width: 20.1119,
    x: 1.94409,
    y: 1.94385
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2978_44115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2978_44115",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1b:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.9102,
    y1: 4.5158,
    y2: 20.7203
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#:r1b:-filter)",
    className: "Ui-outlineFilter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m11.563 3c-2.23648.10793-4.35263 1.04499-5.93577 2.62845-1.58314 1.58347-2.51976 3.69981-2.62723 5.93635 2.1759-.2737 4.19872-1.2641 5.74927-2.81495 1.55053-1.55087 2.54053-3.5739 2.81373-5.74985zm1.8043.09338c-.3046 2.6194-1.4847 5.05924-3.3491 6.92422-1.86433 1.865-4.30376 3.0459-6.92306 3.3514.292 1.8943 1.1802 3.6462 2.53565 5.0014 1.35545 1.3551 3.10758 2.2429 5.00191 2.5345.3053-2.619 1.4857-5.0583 3.3499-6.9228 1.8643-1.8646 4.3033-3.0454 6.9223-3.3511-.2916-1.8947-1.1796-3.64709-2.5351-5.00259s-3.1079-2.24351-5.0025-2.53503zm7.6327 9.34182c-2.176.2734-4.199 1.2637-5.7496 2.8146s-2.5405 3.5741-2.8134 5.7502c2.2364-.1081 4.3524-1.0453 5.9355-2.6287s2.5198-3.6996 2.6275-5.9361z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.563 3c-2.23648.10793-4.35263 1.04499-5.93577 2.62845-1.58314 1.58347-2.51976 3.69981-2.62723 5.93635 2.1759-.2737 4.19872-1.2641 5.74927-2.81495 1.55053-1.55087 2.54053-3.5739 2.81373-5.74985zm1.8043.09338c-.3046 2.6194-1.4847 5.05924-3.3491 6.92422-1.86433 1.865-4.30376 3.0459-6.92306 3.3514.292 1.8943 1.1802 3.6462 2.53565 5.0014 1.35545 1.3551 3.10758 2.2429 5.00191 2.5345.3053-2.619 1.4857-5.0583 3.3499-6.9228 1.8643-1.8646 4.3033-3.0454 6.9223-3.3511-.2916-1.8947-1.1796-3.64709-2.5351-5.00259s-3.1079-2.24351-5.0025-2.53503zm7.6327 9.34182c-2.176.2734-4.199 1.2637-5.7496 2.8146s-2.5405 3.5741-2.8134 5.7502c2.2364-.1081 4.3524-1.0453 5.9355-2.6287s2.5198-3.6996 2.6275-5.9361z",
    fill: "url(#:r1b:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m12.0591 3.06229.0742-.59039-.5944.02868c-2.36063.11392-4.59424 1.103-6.26526 2.77436-1.67101 1.67135-2.65963 3.90517-2.77306 6.26586l-.02856.5943.59037-.0742c2.28611-.2875 4.41139-1.3281 6.04047-2.95753 1.62904-1.62942 2.66924-3.75492 2.95624-6.04108zm1.3842-.46309-.5128-.0789-.0599.51533c-.2916 2.50752-1.4213 4.84315-3.20599 6.62849-1.78473 1.78538-4.11997 2.91578-6.62739 3.20828l-.51527.0601.07903.5127c.30819 1.9994 1.24567 3.8485 2.6763 5.2788 1.43064 1.4303 3.27995 2.3673 5.27942 2.675l.5126.0789.0601-.5152c.2922-2.5071 1.4222-4.8422 3.2068-6.6271 1.7847-1.785 4.1196-2.9153 6.6266-3.208l.5151-.0601-.0789-.5126c-.3076-1.99975-1.2449-3.84934-2.6756-5.28004s-3.2803-2.36798-5.2801-2.67566zm8.0561 9.86.0286-.5943-.5903.0742c-2.2863.2872-4.4117 1.3277-6.0409 2.9572s-2.6692 3.7552-2.956 6.0415l-.074.5904.5943-.0288c2.3606-.1141 4.5941-1.1033 6.265-2.7746 1.671-1.6713 2.6597-3.905 2.7733-6.2656z",
    stroke: "#5800e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.b57c2437be0f65b6b24926c716f71884.svg";
export { ForwardRef as ReactComponent };